import styles from './index.module.scss'
import PictureZoom from '../../PictureZoom'
import { useEffect, useRef, useMemo } from 'react'
import Iconfont from '@utils/Iconfont';
import API from '@api/api'
import PSAIModal from '@PSAIComponents/PSAIModal'
import { message } from 'antd'
import { DISPLAY_TYPE, IMAGE_TYPE } from '@utils/CONST'
import RefImageStrip from './components/RefImageStrip'

const PicModalMiddle = (props) => {
    const {
        item,
        selectedInputImg,
        setSelectedInputImg,
        currentViewIsHD,
        rawTasks,
        displayType,
    } = props

    const image = useMemo(() => {
        return currentViewIsHD ? item?.results?.[0]?.hdImage : item?.results?.[0]?.image
    }, [currentViewIsHD, item])

    const disabledHD = useMemo(() => {
        return item?.results?.[0]?.hdStatus == 'started' ||
            item?.results?.[0]?.hdStatus == 'pending' ||
            item?.results?.[0]?.hdStatus == 'processing'
    }, [item])

    const refImages = useMemo(() => {
        if (item?.imageType !== IMAGE_TYPE.CREATIVE_IMAGE_GEN) return []
        return item?.refImages || []
    }, [item])

    const shouldShowSourceCanvas = useMemo(() => {
        if (item?.imageType !== IMAGE_TYPE.CREATIVE_IMAGE_GEN) return true
        return !!selectedInputImg
    }, [item?.imageType, selectedInputImg])

    const videoRef = useRef()

    useEffect(() => {
        const el = videoRef.current
        if (!el) return
        if (!(image && (image.endsWith('.mp4') || image.endsWith('.MP4')))) return
        el.currentTime = 0
        el.play?.().catch(() => { })
    }, [image])

    const isLoading = useRef(false)
    const toBookmark = (e) => {
        e.stopPropagation()
        if (isLoading.current) return
        isLoading.current = true
        API.bookmarkTask({
            taskId: item?.taskId
        }).then(() => {
            props.fetchProjectDetail()
        }).finally(() => {
            isLoading.current = false
        })
    }

    const deleteClick = (e) => {
        e.stopPropagation()
        PSAIModal.confirm({
            centered: true,
            title: rawTasks?.length == 1 ? "删除该结果及项目" : "删除该结果",
            content: rawTasks?.length == 1 ? "请确认是否删除该结果及项目？" : "请确认是否删除该结果？",
            icon: null,
            onOk: hadnleDeleteTask
        })
    }

    const hadnleDeleteTask = () => {
        return API.deleteTaskImage({
            taskId: item?.taskId,
            imageId: item?.results?.[0]?.id
        }).then((res) => {
            if (res?.code === 0) {
                if (displayType == DISPLAY_TYPE.GENERATE && rawTasks?.length == 1) {
                    props.setProjectId('')
                }
                props.fetchProjectDetail()
                message.success('删除成功');
            } else {
                message.error('删除失败');
            }
        })
    };

    return (
        <div className={`${styles.PicModalMiddle} ${!shouldShowSourceCanvas ? styles.SingleCanvasLayout : ''}`}>
            {shouldShowSourceCanvas && (
                <div className={`${styles.zoomBox} ${refImages.length > 0 ? styles.ZoomBoxWithStrip : ''}`}>
                    <div className={styles.SourceCanvasWrap}>
                        {selectedInputImg && (
                            <PictureZoom
                                key={selectedInputImg}
                                imageUrl={selectedInputImg}
                            />
                        )}
                        {selectedInputImg && <span className={styles.title}>源素材</span>}
                    </div>
                    {refImages.length > 0 && (
                        <RefImageStrip
                            images={refImages}
                            selectedInputImg={selectedInputImg}
                            setSelectedInputImg={setSelectedInputImg}
                        />
                    )}
                </div>
            )}
            <div className={`${styles.zoomBox} ${!shouldShowSourceCanvas ? styles.fullWidthZoomBox : ''}`}>
                {(image && (image.endsWith('.mp4') || image.endsWith('.MP4'))) ? (
                    <div className={styles.videoBox}>
                        <video
                            key={image}
                            ref={videoRef}
                            src={image}
                            muted
                            loop
                            autoPlay
                            playsInline
                            disablePictureInPicture
                        />
                        <i className={styles.VideoIcon}></i>
                        <span className={styles.title}>
                            {currentViewIsHD && (
                                <Iconfont
                                    type="icon-hasHDOutlined"
                                    style={{ color: '#FFCF69', fontSize: 20, marginRight: 5 }}
                                />
                            )}
                            结果视频
                        </span>
                        {disabledHD && <span className={styles.previewHD}><Iconfont type="icon-loadingOutlined" className={styles.Icon} /> 高清预览中</span>}
                    </div>
                ) : (
                    <>
                        {image && (
                            <PictureZoom
                                key={image}
                                imageUrl={image}
                            />
                        )}
                        <span className={styles.title}>
                            {currentViewIsHD && (
                                <Iconfont
                                    type="icon-hasHDOutlined"
                                    style={{ color: '#FFCF69', fontSize: 20, marginRight: 5 }}
                                />
                            )}
                            结果图
                        </span>
                        {disabledHD && <span className={styles.previewHD}><Iconfont type="icon-loadingOutlined" className={styles.Icon} /> 高清预览中</span>}
                        {/* <div className={`${styles.TopBtnGroups}`}>
                            {
                                !item?.orgData && <span onClick={(e) => toBookmark(e)}>
                                    {item.bookmark ? <Iconfont type="icon-StarFilled" style={{ color: '#FFBC3F' }} className={styles.Icon} /> :
                                        <Iconfont type="icon-StarOutlined" className={styles.Icon} />}
                                </span>
                            }
                            {
                                <span onClick={(e) => deleteClick(e)}>
                                    <Iconfont type="icon-DeleteOutlined" className={styles.Icon} />
                                </span>
                            }
                        </div> */}
                    </>
                )}

            </div>
        </div>
    )
}

export default PicModalMiddle
